import React, {useState} from 'react'
import {FAQ} from 'Event/FAQs'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import Settings from 'Event/FAQs/FAQConfig/Settings'
import {REMOVE, useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import {useAddTranslation, useRemoveTranslations} from 'Event/LanguageProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'

export default function FaqConfig(props: {faq: FAQ; id: string}) {
  const {id, faq} = props

  const [rules, setRules] = useState(faq.rules)

  const {
    form: {control, register, watch},
  } = useConfig()
  const save = useSaveTemplate()
  const addTranslation = useAddTranslation()
  const removeTranslations = useRemoveTranslations()

  const handleSave = (data: any) => {
    const question = replaceAtPath(data, `question`, `{{${id}_question}}`)
    const answer = replaceAtPath(data, `answer`, `{{${id}_answer}}`)

    save({
      faq: {
        items: {
          [id]: {
            ...data,
            rules,
          },
        },
      },
      localization: addTranslation({
        [`${id}_question`]: question ?? '',
        [`${id}_answer`]: answer ?? '',
      }),
    })
  }

  const handleRemove = () => {
    save({
      faq: {
        items: {
          [id]: REMOVE,
        },
      },
      localization: removeTranslations([`${id}_question`, `${id}_answer`]),
    })
  }

  const preview = {
    faq: {
      items: {
        [id]: watch(),
      },
    },
  }

  return (
    <Config
      title="FAQ"
      onSave={handleSave}
      onRemove={handleRemove}
      preview={preview}
    >
      <SettingsPanel>
        <Settings control={control} register={register} faq={faq} />
      </SettingsPanel>
      <RulesPanel rules={rules} setRules={setRules} />
    </Config>
  )
}
